module.exports = __webpack_public_path__ + "img/Languages.fce7e719.svg";